<template>
  <div class="show-action-modal-page">
    <ModalShowAction ref="modalRef" @closed="onModalClosed" />
  </div>
</template>

<script>
import { nextTick, onMounted, ref, watch } from "vue";
import { useRoute } from "@/composables/useRoute";
import { useRouter } from "@/composables/useRouter";
import ModalShowAction from "@/modules/action_plans/components/ModalShowAction.vue";

export default {
  name: "ShowActionModalPage",
  components: { ModalShowAction },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const modalRef = ref(null);

    function openFromRoute() {
      const r = route || {};
      const name = r.name;
      const params = r.params || {};
      const planStructureId = params.planStructureId;
      const itemId = params.itemId;
      const actionPlanId = name === "show_action_plan_item" ? params.id : null;

      if (itemId && (planStructureId || actionPlanId)) {
        nextTick(() => {
          modalRef.value?.show({
            itemId,
            planStructureId: planStructureId || undefined,
            actionPlanId: actionPlanId || undefined,
          });
        });
      }
    }

    function onModalClosed() {
      if (router && typeof router.back === "function") {
        router.back();
      }
    }

    onMounted(() => {
      openFromRoute();
    });

    watch(
      () => [route?.params?.itemId, route?.params?.planStructureId, route?.params?.id],
      () => openFromRoute()
    );

    return { modalRef, onModalClosed };
  },
};
</script>

<style scoped>
.show-action-modal-page {
  min-height: 50vh;
}
</style>
